<div class="hvac-rich-text">
    <div *ngIf="parsedText" class='hvac-rich-text-body' [innerHTML]="parsedText | richText"></div>
</div>
